import { Box, styled } from "@mui/material";

export const StyledContentWrapper = styled(Box)({
  width: "100%",
  maxWidth: "1150px",
  margin: "0 auto",
  padding: "32px",
  borderRadius: "16px",

  h2: {
    padding: 0,
    margin: 0,
    marginBottom: "12px",
  },
});
